import cx from 'clsx';
import type { ReactNode } from 'react';
import { usePdfPreviewContext } from '../../pdf-preview-context.tsx';
import styles from './page-number.module.css';

export function PageNumber(): ReactNode {
  const { pageCount } = usePdfPreviewContext();

  if (pageCount) {
    return (
      <p
        className={cx('body-3', styles['page-number'])}
        data-testid="pdf-preview-de-footer-page-count"
      >
        {pageCount}
      </p>
    );
  }

  return null;
}
